import { NitroModules } from "react-native-nitro-modules";
function readAppInfo() {
  var _native_version, _native_build, _native_applicationId;
  if (!NitroModules.hasHybridObject("OneAppInfo")) {
    return {
      version: null,
      build: null,
      applicationId: null
    };
  }
  var native = NitroModules.createHybridObject("OneAppInfo");
  return {
    version: (_native_version = native.version) !== null && _native_version !== void 0 ? _native_version : null,
    build: (_native_build = native.build) !== null && _native_build !== void 0 ? _native_build : null,
    applicationId: (_native_applicationId = native.applicationId) !== null && _native_applicationId !== void 0 ? _native_applicationId : null
  };
}
var AppInfo = Object.freeze(readAppInfo());
export {
  AppInfo
};
//# sourceMappingURL=index.native.js.map
